/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdsonstiges11Inputs */

const en__field_enum_sdsonstiges11 = /** @type {(inputs: _Field_Enum_Sdsonstiges11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de__field_enum_sdsonstiges11 = /** @type {(inputs: _Field_Enum_Sdsonstiges11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {_Field_Enum_Sdsonstiges11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdsonstiges11 = /** @type {((inputs?: _Field_Enum_Sdsonstiges11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdsonstiges11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdsonstiges11(inputs)
	return de__field_enum_sdsonstiges11(inputs)
});
export { _field_enum_sdsonstiges11 as "_field_enum_SDSONSTIGES" }